<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :title="$i18n.t('dialog.title.downloadData')"
    dialog-width="30%"
    max-height="90vh"
    header-shadow
  >
    <template #body>
      <v-col cols="12" class="text-left">
        <data-input
          :value="!!selectedItems.length"
          :label="$i18n.t('dialog.selectAll')"
          :data-type="{ name: 'checkbox' }"
          :on-icon="
            !!selectedItems.length && selectedItems.length !== allAttributes.length
              ? 'mdi-minus-box'
              : 'mdi-checkbox-marked'
          "
          hide-details
          @input="toogleSelectAll"
        />
        <v-treeview v-model="selectedItems" :items="computedItems" selected-color="primary" selectable dense />
      </v-col>
    </template>
    <template #buttons>
      <v-row no-gutters style="gap: 0.5rem 1rem">
        <v-col cols="auto">
          <dots-menu :items="dotsItems" :disabled="loading" v-on="listeners">
            <template #activator="{ on }">
              <button-main-dialog
                v-on="on"
                translation-path="dialog.download"
                style="margin-right: 0 !important"
                :loading="loading"
              />
            </template>
          </dots-menu>
        </v-col>
        <v-col cols="auto">
          <button-main-dialog
            cancel
            translation-path="dialog.disagree"
            style="margin-right: 0 !important"
            @click="
              () => {
                computedIsVisible = false;
              }
            "
          />
        </v-col>
      </v-row>
    </template>
  </main-large-dialog>
</template>

<script>
import { get, call } from 'vuex-pathify';

import selectedFeatures from '@/mixins/selectedFeatures';
import filters from '@/mixins/filters';

import MainLargeDialog from '@/components/MainLargeDialog';
import ButtonMainDialog from '@/components/ButtonMainDialog';
import DataInput from '@/components/DataInput';
import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'DownloadAttributesDialog',
  components: {
    MainLargeDialog,
    ButtonMainDialog,
    DataInput,
    DotsMenu,
  },
  mixins: [selectedFeatures, filters],
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    layerId: {
      type: [Number, String],
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    hasGeometry: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    loading: false,
    selectedItems: [],
  }),
  computed: {
    isUseQualifiedNames: get('layers/metadata@:currentLayerDataSourceName.attributes_use_datasource_qualified_names'),
    idPropertyName: get('layers/metadata@:currentLayerDataSourceName.attributes_schema.id_name'),
    currentLayerDataSourceName: get('layers/currentLayer@data_source_name'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    dotsItems() {
      return [
        ...(this.hasGeometry
          ? [
              { name: 'shp', customName: this.$i18n.t('default.shp') },
              { name: 'geojson', customName: this.$i18n.t('default.geojson') },
            ]
          : []),
        { name: 'csv', customName: this.$i18n.t('default.csv') },
        { name: 'xlsx', customName: this.$i18n.t('default.xlsx') },
      ];
    },
    listeners() {
      return this.dotsItems.reduce((total, current) => {
        return {
          ...total,
          [current.name]: () => {
            this.downloadFile(current.name);
          },
        };
      }, {});
    },
    computedItems() {
      return this.items.map((el, idx) => {
        return {
          id: idx,
          name: el.label,
          children: el.elements
            .filter(el => el.attribute !== this.idPropertyName)
            .map(el => {
              return {
                id: el.attribute,
                name: el.label,
              };
            }),
        };
      });
    },
    allAttributes() {
      return this.computedItems
        .map(item => item.children)
        .flat()
        .map(attr => attr.id);
    },
  },
  mounted() {
    this.selectedItems = this.allAttributes;
  },
  methods: {
    exportLayerFeatures: call('layers/exportLayerFeatures'),
    async downloadFile(format) {
      this.loading = true;
      const features_filter = this.isAnyFeatureSelected
        ? {
            $IN: {
              [this.isUseQualifiedNames
                ? this.idPropertyName
                : `${this.currentLayerDataSourceName}.${this.idPropertyName}`]: this.currentLayerSelectedFeatures,
            },
          }
        : this.handleGetFilter();
      await this.exportLayerFeatures({
        layer_id: this.layerId,
        attributes: this.selectedItems,
        format,
        features_filter,
      });
      this.loading = false;
    },
    toogleSelectAll(value) {
      if (value) this.selectedItems = this.allAttributes;
      else this.selectedItems = [];
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-label {
    color: rgba(0, 0, 0, 0.87);
  }
  .v-treeview-node__root {
    padding-left: 0;
  }
  .v-input__control .v-icon {
    font-size: 24px;
  }
}
</style>
